module.exports = __webpack_public_path__ + "77956550.webp";